// Module
var code = `<!-- clNote — one-line inline annotation (beta, deprecated, roadmap, warning, info).
     Data shape: { icon: "info"|"beta"|"deprecated"|"warning"|"roadmap", text: "markdown" }
     Compact single-line treatment; use clCallout for anything longer. -->
<div class="block-cl-note block-cl-note--{{icon}}">


    <i class="fa-solid {{attrIcon}}"></i>
    <span class="block-cl-note__text">{{text}}</span>
</div>
`;
// Exports
module.exports = code;